import { jsx as _jsx } from "react/jsx-runtime";
function IconBusinessSolutions(props) {
    return (_jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconBusinessSolutions", ...props, children: _jsx("path", { d: "M2 17V3h20v14h-8v2h2v2H8v-2h2v-2H2zM20.5 4.5h-17v11h17v-11zM19 6v5h-1.5V8.542l-5.508 5.052-2.65-2.742-4.098 3.351-.95-1.16 5.167-4.225 2.594 2.683L16.416 7.5H14V6h5z", fill: "currentColor" }) }));
}
export default IconBusinessSolutions;
//# sourceMappingURL=IconBusinessSolutions.js.map